/**
 * @package COMMON
 *
 */
(function (window, document, $, undefined) {
  var COMMON = {};

  function expose() {
    var oldCOMMON = window.COMMON;

    COMMON.noConflict = function () {
      window.COMMON = oldCOMMON;
      return this;
    };

    window.COMMON = COMMON;
  }

  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = COMMON;
  } else if (typeof define === 'function' && define.amd) {
    define(COMMON);
  }

  if (typeof window !== 'undefined') {
    expose();
  }

  COMMON.$container = $('#content');

}(window, document, window.jQuery));
